// removed by extract-text-webpack-plugin
module.exports = {"container":"app-2HuoZgNY","content":"app-1AVJIx2g","top":"app-26F3-RaZ","header":"app-jdyPdW7z","logo":"app-3eA-z4mn","title":"app-bWCRHo4w","desc":"app-2wpBzUPd"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-mian-apps/wbap-admin-root/components/UserLayout/index.less
// module id = 692
// module chunks = 0